<div class="language-wrapper">
  <mat-select
    (valueChange)="onChange($event)"
    *ngIf="translate?.currentLang"
    [disabled]="disabled"
    [ngClass]="'lang-' + translate?.currentLang"
    [value]="translate.currentLang"
  >
    <mat-option class="language-option" *ngFor="let lang of translate.getLangs()" [value]="lang">
      <span
        [ngClass]="'lang-' + lang"
        class="d-flex align-items-center bg_main_gray_02 bordered mb-0 border-radius-20px"
      >
        <span
          class="d-inline-block border-radius-100 box-shadowed mb-0 mr-3 w30x30"
          [ngClass]="{selected: lang === translate.currentLang}"
        ></span>
        <span class="fs-15">{{ languages[lang] }}</span>
      </span>
    </mat-option>
  </mat-select>
</div>
